import SEO from "../../../data/seo";
import HeaderTwo from "../../../layout/headers/header-two";
import BreadCrumb from "../../common/breadcrumb";
import BlogStandardMain from "./blog-standard";
import FooterTwo from "../../../layout/footers/footer-two";

const BlogStandardPage = () => {
    return (
        <>
            <SEO pageTitle="Blog"/>
            <HeaderTwo/>
            <BreadCrumb title="Blog" items={[
                {
                    "label": "Blog"
                }
            ]}/>
            <BlogStandardMain/>
            <FooterTwo/>
        </>
    );
};

export default BlogStandardPage;